import { render } from "./BannerComponent.vue?vue&type=template&id=222b453f&scoped=true&ts=true"
import script from "./BannerComponent.vue?vue&type=script&lang=ts"
export * from "./BannerComponent.vue?vue&type=script&lang=ts"

import "./BannerComponent.vue?vue&type=style&index=0&id=222b453f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\RuZja\\Desktop\\Projects\\ruzja\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222b453f"]])

export default __exports__